import React, { Component } from 'react';
import LeftMenu from './Menu/LeftMenu'
import { Drawer } from 'antd';
import { BarsOutlined } from '@ant-design/icons';
class Navbar extends Component {
    state = {
        visible: false
    }
    showDrawer = () => {
        this.setState({
            visible: true,
        });
    };
    onClose = () => {
        this.setState({
            visible: false,
        });
    };
    render() {
        return (
            <>
                    <BarsOutlined className="barsMenu"  onClick={this.showDrawer}>
                    </BarsOutlined>
                    <Drawer
                        title="TrustkeyCrypro"
                        closable={true}
                        onClose={this.onClose}
                        visible={this.state.visible}
                        bodyStyle={{ padding: '10px 0px' }}
                    >
                        <LeftMenu />
                    </Drawer>
                </>
        );
    }
}
export default Navbar;